export const checkObjectLength = props => {

    if(props && Object.keys(props).length > 0 ){
        return true;
    }else{
        return false;
    }
}